import theme from '@/style';
import {SVGProps} from '@/types';
import React from 'react';

const CheckIcon = ({
  color = theme.basicColor.primary,
  width = 12,
  height = 12,
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 5.5L5.38889 8.61111L11 3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckIcon;
